/**
 * Logging utility for web admin with environment-aware behavior
 * 
 * - debug: Only logs in development (NODE_ENV !== 'production')
 * - info: Always logs
 * - error: Always logs
 * - warn: Always logs
 */

/**
 * Debug logging - only appears in development builds
 * Use for verbose debugging that shouldn't appear in production
 */
const debug = (...args: any[]): void => {
  if (process.env.NODE_ENV === 'development') {
    console.log(...args);
  }
};

/**
 * Info logging - always logs
 * Use for important operational information
 */
const info = (...args: any[]): void => {
  console.log(...args);
};

/**
 * Error logging - always logs
 * Use for errors that need investigation
 */
const error = (...args: any[]): void => {
  console.error(...args);
};

/**
 * Warning logging - always logs
 * Use for warnings that need attention
 */
const warn = (...args: any[]): void => {
  console.warn(...args);
};

export const logger = {
  debug,
  info,
  error,
  warn,
};

// Export individual functions for convenience
export { debug, info, error, warn };
